/**
 * Created by lari on 27/04/2017.
 */
(function () {
    'use strict';
    angular.module('vcexam')
      .component('addexamdiagnoses', {
        restrict: 'E',
        bindings: {
          patientid: '<'
        },
        templateUrl: 'vcexam/addexamdiagnoses-component.tpl.html',
        controllerAs: 'vm',
        controller: ['$log', 'Rlog', 'Exam', 'vertxEventBusService', '$window',
          function ($log, Rlog, Exam, vertxEventBusService, $window) {
            let vm = this;
            vm.showexam = [];
            // vm.deleteExam = deleteExam;
            // vm.closeExam = closeExam;
            // vm.showeditor = showeditor;
            // vm.showview = showview;
/*            vm.$onInit = function () {
              // $log.debug('******* addexam init patientid : ', vm.patientid);
              if (angular.isDefined(vm.patientid)) {
                let query = {patientid: vm.patientid};
                Exam.$search(query).$then(function (exams) {
                  vm.examinations = exams;
                  $log.debug('addexamdiagnoses onInit loaded exams for patient ', vm.patientid, exams);
                });
              }
            };*/

            // vm.consultid might be late propagating, get exams on first change
            vm.$onChanges = function (changes) {
              if (!changes.isFirstChange) {
                // if (angular.isDefined(changes.consultid.currentValue)) {
                vm.patientid = changes.patientid.currentValue;
                if (angular.isDefined(vm.patientid)) {
                  Exam.$search({patientid: vm.patientid}).$then(function (exams) {
                    vm.examinations = exams;
                    $log.debug('addexamdiagnoses onChanges loaded exams for patient ', vm.patientid, exams);
                  }, function (err) {
                    $log.error('exam lookup failed for consultid id: ', vm.patientid, err);
                    Rlog.error('exam', 'currentexams', 'exam lookup failed', {patientid: vm.patientid});
                  });
                }
              }
            };


            vm.sprpreview = `Die Untersuchung wurde nachträglich editiert. Sobald die Änderung abgeschlossen ist, 
              wird ein neues PDF File erzeugt. Bis der Editiervorgang abgeschlossen ist, kann eine PDF Vorschau 
              angezeigt werden. `;


          }] // controller
      }); // component

// klammerfriedhof
  }());